












































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class DateRangePicker extends Vue {
  @Prop({ default: "Dátumtól" }) fromLabel!: string;
  @Prop({ default: "Dátumig" }) toLabel!: string;
  @Prop({ default: "min-width: 120px; width: 120px; padding-left: 0; padding-right: 0;" }) inputStyle!: string;
  @Prop({ required: true }) value!: { from: string; to: string };

  dateFromMenu = false;
  dateToMenu = false;
  dateFrom = "";
  dateTo = "";

  @Watch("value", { immediate: true, deep: true })
  onValueChange(newValue: { from: string; to: string }) {
    this.dateFrom = newValue.from || "";
    this.dateTo = newValue.to || "";
  }

  get formattedDateFrom() {
    if (!this.dateFrom) { return ""; }
    return new Date(this.dateFrom).toLocaleDateString("hu-HU");
  }

  get formattedDateTo() {
    if (!this.dateTo) { return ""; }
    return new Date(this.dateTo).toLocaleDateString("hu-HU");
  }

  confirmFromDate() {
    this.dateFromMenu = false;
    this.emitChange();
  }

  confirmToDate() {
    this.dateToMenu = false;
    this.emitChange();
  }

  clearFromDate() {
    this.dateFrom = "";
    this.dateFromMenu = false;
    this.emitChange();
  }

  clearToDate() {
    this.dateTo = "";
    this.dateToMenu = false;
    this.emitChange();
  }

  emitChange() {
    this.$emit("input", {
      from: this.dateFrom,
      to: this.dateTo
    });
  }
}
